import adverts from '../modules/adverts';

adverts.init();
